/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Category_Items_CountInputs */

const en_directory_category_items_count = /** @type {(inputs: Directory_Category_Items_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tools`)
};

const zh_directory_category_items_count = /** @type {(inputs: Directory_Category_Items_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个工具`)
};

/**
* | output |
* | --- |
* | "{count} tools" |
*
* @param {Directory_Category_Items_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_category_items_count = /** @type {((inputs: Directory_Category_Items_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Category_Items_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_category_items_count(inputs)
	return zh_directory_category_items_count(inputs)
});
export { directory_category_items_count as "directory.category.items_count" }